import { DartyAuthResponseSchema, DartySessionSchema, getDartyExpiration } from "../session/darty"
import {
    DartyOctopusAuthResponseSchema,
    DartyOctopusSessionSchema,
    getDartyOctopusExpiration,
} from "../session/dartyOctopus"

export const session = {
    darty: {
        schema: DartySessionSchema,
        authResponseSchema: DartyAuthResponseSchema,
        getExpiration: getDartyExpiration,
    },
    dartyOctopus: {
        schema: DartyOctopusSessionSchema,
        authResponseSchema: DartyOctopusAuthResponseSchema,
        getExpiration: getDartyOctopusExpiration,
    },
} as const
